import { IconButton } from '../IconButton'
import { svgColor, svgUri } from '../../helpers'
import { StyleFn } from '..'

export const IconArrowForward = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 7L21 12M21 12L16 17M21 12H3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>',
}

export const IconArrowBack = {
  data: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 17L3 12M3 12L8 7M3 12H21" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>',
}

export const Pagination: StyleFn = (theme) => {
  const { color, font, size } = theme
  const { root, _ghost, _primary, _secondary, _small } = IconButton(theme)
  const bgSvgColor = color.type === 'light' ? color.palette.primaryblue['60'] : color.palette.white

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      // "&:last-child": {
      //   marginRight: 0,
      // },
    },
    legend: {
      flex: 1,
      fontSize: font.size.small,
      color: color.palette.coolgrey[50],
    },
    nav: {
      display: 'flex',
    },
    // class for rowsperpage and goto
    side: {
      display: 'flex',
      fontSize: `${font.size.small}`, // "0.875rem",
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: font.weight.bold,
      // increase specficity of row input to take width of the content, as ds-select has 100% width
      '& $side_input': {
        width: 'auto',
        paddingRight: size.spacing[48],
      },
      '& $side_right_width': {
        minWidth: size.spacing[80],
      },
    },
    side_right: {
      marginLeft: size.spacing[32],
    },
    side_left: {
      marginRight: size.spacing[32],
    },
    side_input: {},
    side_label: {
      marginRight: size.spacing['8'],
      color: color.palette.coolgrey[60],
    },
    side_right_width: {},
    item: {
      ...root,
      ..._ghost,
      ..._small,
      padding: 0,
      marginRight: size.spacing[8],
      color: color.palette.coolgrey[60],
      '&:last-child': {
        marginRight: 0,
      },
    },
    item_active: {
      ..._primary,
    },
    item_prev: {
      ..._secondary,
      marginRight: `${size.spacing[32]} !important`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left 50% top 50%',
      backgroundSize: size.spacing[20],
      backgroundImage: svgUri(svgColor(IconArrowBack.data, bgSvgColor)),
    },
    item_next: {
      ..._secondary,
      marginLeft: size.spacing[24],
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left 50% top 50%',
      backgroundSize: size.spacing[20],
      backgroundImage: svgUri(svgColor(IconArrowForward.data, bgSvgColor)),
    },
  }
}
